// Registers each cart bundle item's remove button
document.body.addEventListener("click", async (event) => {
  if (
    !event.target.matches("button.bundle-remove") &&
    !event.target.parentElement?.matches("button.bundle-remove") &&
    !event.target.parentElement?.parentElement?.matches("button.bundle-remove")
  )
    return;

  const bundle_id =
    event.target.getAttribute("data-bundle-id") ||
    event.target.parentElement?.getAttribute("data-bundle-id") ||
    event.target.parentElement?.parentElement?.getAttribute("data-bundle-id");

  try {
    // Get current cart contents
    const cart = await (await fetch("/cart.js")).json();

    // Create data object for cart update AJAX call
    const data = {
      updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
    };

    // API call to update the cart contents and set the bundle item quantities to 0
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    });

    response.ok && (window.location.href = "/cart");
  } catch (error) {
    console.error(error);
  }
});

//custom message for bundle
(() => {
  if (window.location.href.indexOf("/tools/bundle-subscriptions/bundle/7272982380646") === -1) return;
  const babReady = new MutationObserver(() => {
    const cards = document.querySelectorAll(".bundle-product-card")?.length;
    if (cards && cards > 0) {
      const bundleMsg = document.createElement("div");
      bundleMsg.classList.add("bundleMsg");
      bundleMsg.innerHTML = `
          <h2>Mix and match your subscription box</h2>
          <p>${window.location.search.includes("variant=41464804606054") ? "Free shipping!" : "Receive free shipping when you bundle 12!"}</p>
        `;
      document.querySelector(".awt-bab-open main.bundle-create-content").prepend(bundleMsg);
      babReady.disconnect();
    }
  });
  babReady.observe(document.body, { childList: true, subtree: true, attributes: true });

  setTimeout(() => {
    babReady.disconnect();
    console.console.log("Disconnected");
  }, 4000);
})();

window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    addToCartRedirect: ({ cartItems, discountCode }) => {
      const openCartEvent = new Event("reloadCartAndOpen", { cartItems, discountCode });
      window.dispatchEvent(openCartEvent);
      window.location.assign(`/discount/${discountCode}?redirect=/checkout`);
    }
  }
});
